const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Salut',
    'Ref: Page content body':
      "À l'arrivée et au départ, assurez-vous de vous souvenir de scanner votre bus de code QR",
  },
};
export default labels;
